import { getPrefixedRoute } from 'services/theming';

/**
 * Hook to get the route for requesting a quote.
 * @returns A function that returns the route to the request quote form
 */
const useRequestQuoteRoute = (profileID?: string) => {
  return getPrefixedRoute(`/quote/${profileID}`);
};

export default useRequestQuoteRoute;
